import classNames from 'classnames';
import { useI18n } from '@/libraries/contexts/i18n-context';
import { useSwiper } from 'swiper/react';
import Button from '@/components/molecules/button/button';
import styles from './image-gallery-block-controls.module.scss';

export interface ImageGalleryBlockControlsProps {
  /** The class name to apply */
  className?: string;
  /** An event that is triggered on click */
  onClick?: () => void;
}

const ImageGalleryBlockControls = ({
  className,
  onClick,
}: ImageGalleryBlockControlsProps) => {
  const swiper = useSwiper();
  const { t } = useI18n();

  return (
    <div className={classNames(styles.component, className)}>
      <Button
        aria-label={t('items.common.words.previousImage')}
        className={styles.button}
        icon="ChevronLeft"
        onClick={() => swiper.slidePrev()}
        variant="tertiary"
      />

      <Button
        aria-label={t('items.common.words.nextImage')}
        className={styles.button}
        icon="ChevronRight"
        onClick={() => swiper.slideNext()}
        variant="tertiary"
      />

      <Button
        aria-label={t('items.common.words.expand')}
        className={styles.button}
        icon="Expand"
        onClick={() => onClick?.()}
        variant="tertiary"
      />
    </div>
  );
};

ImageGalleryBlockControls.displayName = 'ImageGalleryBlockControls';

export default ImageGalleryBlockControls;
